import './styles.scss';
import mask from 'images/mission-mask.svg';

const MissionAndValuesSection = ({ background = '', title = '', data = [] }) => {
    const maskStyle = { maskImage: `url('${mask}')`, WebkitMaskImage: `url('${mask}')` };

    if (!data.length) return false;

    return (
        <section className="mission-values-section container">
            <div className="mission-section">
                <div className="mission-section__gradient" />
                <div className="mission-section__mask" style={maskStyle}>
                    <img src={background} alt="background" />
                </div>
                <div className="mission-section__title">{title}</div>
            </div>
            <div className="values-section" style={{ backgroundImage: `url("${background}")` }}>
                {data?.map((card, index) => (
                    <div className="values-card-wrapper" key={index}>
                        <div className="angle-decor" />
                        <div className="values-card">
                            <div className="gradient-number light">
                                <span>{index + 1}</span>
                            </div>
                            {card.title && <div className="values-card__title">{card.title}</div>}
                            {card.text && <div className="values-card__text">{card.text}</div>}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default MissionAndValuesSection;
